"use client"

import { useState, useEffect } from "react"
import { ArrowRight, AlertTriangle, Plus, Clock } from "lucide-react"

import { ArrowDownLeft, ArrowUpRight, RefreshCw, CreditCard, Bell, Menu, Sparkles, Search } from "lucide-react"
import { TransactionCard } from "./layouts/transaction-card"
import WrapUpP2p from "./layouts/WrapUpP2p"
import { allRemoteSettingsSelect, exchangeSelect, homeScreenStatSelect, peerSelect, userSelect } from "../../../redux/selectors"
import { useDispatch, useSelector } from "react-redux"
import { exchangeActions, peerActions } from "../../../redux/actions"
import { money, notify } from "../../../utility/Helper1"
import { useNavigate } from "react-router-dom";
import {
  Button,
  CircularProgress
} from "@mui/material"

import Countdown from 'react-countdown';
import PeeredOrders from './PeeredOrders'


const CountdownTimer = ({ targetTime, prefix }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetTime));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetTime));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  function calculateTimeLeft(targetTime) {
    const difference = new Date(targetTime) - new Date();
    if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return (
    <div className="text-white font-medium">
      {prefix}
      <span className="text-cyan-300">
        {timeLeft.days > 0 && (
          <>
            <span>{timeLeft.days}d </span>
          </>
        )}
        {timeLeft.hours.toString().padStart(2, '0')}:
        {timeLeft.minutes.toString().padStart(2, '0')}:
        {timeLeft.seconds.toString().padStart(2, '0')}
      </span>
    </div>
  );
};

export default function Home() {

  const site_settings = useSelector(allRemoteSettingsSelect);
  const finance = useSelector(homeScreenStatSelect)
  const settings = site_settings?.operational_settings;
  const userData = useSelector(userSelect);
  const [marketLoading, setMarketLoading] = useState(false)


  const peerRoot = useSelector(peerSelect);
  const exchangeRoot = useSelector(exchangeSelect);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const actions = [
    { id: "send", label: "New Bid", to: '/submit/request', icon: ArrowUpRight, color: "from-purple-600 to-indigo-600" },
    { id: "swap", label: "All Bids", to: '/list', icon: RefreshCw, color: "from-cyan-600 to-blue-600" },
    { id: "receive", label: "Receive", to: '/receive/request', icon: ArrowDownLeft, color: "from-green-600 to-emerald-600" },
    { id: "buy", label: "Bank", to: '/banking/system', icon: CreditCard, color: "from-fuchsia-600 to-pink-600" },
  ]

  const onLoadPeer = () => {
    dispatch(peerActions.onGet("p2p/load/peer", response => {

    }))
  }

  const onLoadPH = () => {
    dispatch(exchangeActions.onGetExchange("p2p/load/all", response => {

    }))
  }


  useEffect(() => {
    onLoadPeer()
    onLoadPH()
  }, [])




  const getMarketStatus = () => {
    const now = new Date();
    const marketStart = new Date(settings?.p2p_markettimeStart);
    const marketEnd = new Date(settings?.p2p_markettimeEnds);

    if (now < marketStart) {
      return "UPCOMING"; // Market hasn't opened yet
    } else if (now > marketEnd) {
      return "CLOSED"; // Market has closed
    } else {
      return "OPEN"; // Market is currently open
    }
  };





  // Calculate market progress percentage
  const calculateMarketProgress = () => {
    if (!settings?.p2p_markettimeStart || !settings?.p2p_markettimeEnds) return 0

    const start = new Date(settings.p2p_markettimeStart).getTime()
    const end = new Date(settings.p2p_markettimeEnds).getTime()
    const now = Date.now()

    if (now < start) return 0
    if (now > end) return 100

    return ((now - start) / (end - start)) * 100
  }



  const handleGoToMarket = () => {
    const allAccountPH = exchangeRoot?.reduce((sum, item) => sum + (Number(item.ph) || 0), 0)

    // if (!getMarketStatus() != 'OPEN') {
    //   notify('Market is currently closed', 0)
    //   return;
    // }

    if (allAccountPH <= 0) {
      notify("No Bid found.", 0)
      return
    }

    if (marketLoading) {
      notify("Please wait", 0)
      return
    }

    setMarketLoading(true)

    dispatch(
      peerActions.onPost({ loadMarket: true }, `p2p/market/time`, (response) => {

        notify('Please refresh your dashboard after the countdown', 1)

        if (response.code == 1) {
          // notify('Successful. Please visit Exchange to see your orders', 1)
        } else {
          // notify('No order peered. Try again', 0)
        }
        // setMarketLoading(false)

      }),
    )
  }

  const pendingCount = peerRoot?.filter((el) => ["YES", "NO"].includes(el.status))
 

  return <WrapUpP2p>
    <div className="rounded-xl bg-gradient-to-r from-purple-900/40 to-blue-900/40 p-6 backdrop-blur-md border border-purple-500/20 shadow-[0_0_15px_rgba(149,76,233,0.25)]">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-white">Hi, {userData?.username}</h2>
          <div className="mt-1 flex items-center">
            <Sparkles className="mr-1 h-4 w-4 text-yellow-400" />
            <span className="text-sm text-purple-200">Balance Card</span>
          </div>
        </div>
        {Number(finance?.[0]?.oldwallet ?? 0) > 0 && <div className="text-right">
          <p className="text-sm text-purple-200">Old Wallet</p>
          <p className="text-2xl font-bold text-white">{money(Number(finance?.[0]?.oldwallet))}</p>
        </div>}
        {Number(finance?.[0]?.oldwallet ?? 0) == 0 && <div className="text-right">
          <p className="text-sm text-purple-200">Total Balance</p>
          <p className="text-2xl font-bold text-white">{money(Number(finance?.[0]?.balance) + Number(finance?.[0]?.commission))}</p>
        </div>}
      </div>

      {finance?.map((wallet, index) => (<div className="mt-6 grid grid-cols-2 gap-4">
        <div className="rounded-lg bg-white/5 p-3">
          <div className="flex items-center justify-between">
            <p className="text-sm text-purple-200">Wallet</p>
          </div>
          <p className="mt-1 font-medium text-white">{money(wallet.balance)}</p>
        </div>
        <div className="rounded-lg bg-white/5 p-3">
          <div className="flex items-center justify-between">
            <p className="text-sm text-purple-200">Bonus</p>
          </div>
          <p className="mt-1 font-medium text-white">{money(wallet.commission)}</p>
        </div>
      </div>))}

    </div>




    {(pendingCount?.length ?? 0) > 0 && <div className="rounded-xl bg-gradient-to-r from-purple-600/90 to-cyan-500/90 p-6 backdrop-blur-md border border-purple-500/30 shadow-[0_0_20px_rgba(149,76,233,0.3)] relative overflow-hidden">
      {/* Glow effects */}
      <div className="absolute -top-4 -left-4 w-24 h-24 bg-purple-400 rounded-full opacity-20 blur-2xl"></div>
      <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-cyan-400 rounded-full opacity-15 blur-3xl"></div>

      <div className="relative z-10">
        <div className="flex items-start gap-3 mb-4">
          <div className="flex-shrink-0">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
              <AlertTriangle className="h-5 w-5 text-white" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold text-white mb-2">Pending Payments</h3>
            <p className="text-white/90 text-sm leading-relaxed">
              You have <span className="font-semibold text-white">{pendingCount?.length} pending payments</span> to complete.
              Please finalize these transactions promptly to maintain your account access.
            </p>
          </div>
        </div>

        <button
          onClick={() => navigate('/my/p2p')}
          className="w-full mt-4 bg-white/20 hover:bg-white/30 text-white font-medium py-2.5 px-4 rounded-lg transition-all duration-200 border border-white/20 hover:border-white/40 flex items-center justify-center gap-2"
        >
          <CreditCard className="h-4 w-4" />
          Go to Payment Section
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>}



    <div className="grid grid-cols-4 gap-2 md:gap-4">
      {actions.map((action) => (
        <button
          onClick={() => navigate(action.to)}
          key={action.id}
          className="flex flex-col items-center rounded-xl bg-gradient-to-br from-gray-900/80 to-gray-800/50 p-3 backdrop-blur-sm border border-purple-500/10 hover:border-purple-500/30 transition-all shadow-[0_0_10px_rgba(149,76,233,0.1)] hover:shadow-[0_0_15px_rgba(149,76,233,0.2)]"
        >
          <div
            className={`flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-r ${action.color} shadow-lg`}
          >
            <action.icon className="h-5 w-5 text-white" />
          </div>
          <span className="mt-2 text-xs font-medium text-white">{action.label}</span>
        </button>
      ))}
    </div>



    {settings?.p2p_use_time_based_peering == 1 && (
      <div className="bg-black bg-opacity-40 backdrop-blur-sm -4 border-b border-purple-900">
        <div className="max mx-auto">
          <div className="rounded-xl bg-gradient-to-r from-indigo-900 to-purple-900 p-6 shadow-lg relative overflow-hidden">
            {/* Glow effect */}
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-purple-500 rounded-full opacity-20 blur-3xl"></div>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-cyan-500 rounded-full opacity-20 blur-3xl"></div>

            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 relative z-10">
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-1">Market Access</h3>
                <p className="text-purple-200 mb-3">
                  {new Date(settings?.p2p_markettimeStart) > new Date()
                    ? "Market opens soon"
                    : new Date(settings?.p2p_markettimeEnds) < new Date()
                      ? "Market is currently closed"
                      : "Market is now open"}
                </p>

                {/* Countdown timer */}
                <div className="mb-2">
                  {new Date(settings?.p2p_markettimeStart) > new Date() ? (
                    <CountdownTimer targetTime={settings?.p2p_markettimeStart} prefix="Opens in: " />
                  ) : new Date(settings?.p2p_markettimeEnds) > new Date() ? (
                    <CountdownTimer targetTime={settings?.p2p_markettimeEnds} prefix="Closes in: " />
                  ) : (
                    <span className="text-purple-300">Market closed</span>
                  )}
                </div>

                <div className="flex justify-between text-xs text-purple-300 mt-1">
                  <span>
                    {new Date(settings?.p2p_markettimeStart).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                  {/* <span>
                    {new Date(settings?.p2p_markettimeEnds).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span> */}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  variant="contained"
                  onClick={() => window.confirm('If you click OK, a payment order will be allocated to you. Priority is given to users who access the market early. When the market closes, Refresh the dashboard to see if your bid was allocated. Bidders who do not not click OK will not be allocated.') && handleGoToMarket()}
                  disabled={marketLoading}
                  className="bg-gradient-to-r from-purple-500 to-pink-500 text-white font-semibold px-4 py-2 rounded-lg shadow-lg hover:shadow-purple-500/20 transition-all disabled:opacity-60"
                >
                  {marketLoading ? <CircularProgress size={24} color="inherit" /> : "Visit Market"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}

    <PeeredOrders singly={true} />


  </WrapUpP2p>

  return

}